import { useModal } from '../../hooks/modals';
import Button from '../common/forms/Button';
import ButtonLoading from '../common/forms/ButtonLoading';
import Icon from 'components/common/Icon';
import IconBackground from '../common/icons/IconBackground';
import Modal, { ModalHeader } from '../common/Modal';

const DeleteQuestionBlock = ({
  isDeleting,
  onConfirmDelete,
}: {
  isDeleting: boolean;
  onConfirmDelete(): void;
}): JSX.Element => {
  const {
    isOpen: isConfirmDelete,
    onCloseModal,
    setIsOpen: setIsConfirmDelete,
  } = useModal();

  return (
    <>
      <IconBackground
        onClick={() => {
          setIsConfirmDelete(true);
        }}
        title="Delete"
      >
        <div className="w-3 h-3">
          <Icon id="trash" />
        </div>
      </IconBackground>
      {isConfirmDelete && (
        <DeleteQuestionBlockModal
          isDeleting={isDeleting}
          onCloseModal={onCloseModal}
          onConfirmDelete={onConfirmDelete}
        />
      )}
    </>
  );
};

export default DeleteQuestionBlock;

const DeleteQuestionBlockModal = ({
  isDeleting,
  onCloseModal,
  onConfirmDelete,
}: {
  isDeleting: boolean;
  onCloseModal(): void;
  onConfirmDelete(): void;
}): JSX.Element => {
  return (
    <Modal
      header={
        <ModalHeader onClickClose={onCloseModal}>
          Delete Question Block
        </ModalHeader>
      }
      onCloseModal={onCloseModal}
      position="top"
    >
      <p>Are you sure you want to delete this question block?</p>

      <div className="mt-8 flex gap-3 flex-row-reverse">
        <ButtonLoading
          grow
          hierarchy="destructive"
          isLoading={isDeleting}
          onClick={onConfirmDelete}
          size="lg"
          type="button"
        >
          Delete
        </ButtonLoading>
        <Button
          grow
          hierarchy="secondary-gray"
          onClick={onCloseModal}
          size="lg"
          type="button"
        >
          Cancel
        </Button>
      </div>
    </Modal>
  );
};
